<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title> Filtros </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <span>Linea </span>
              <v-autocomplete
                v-model="form.line"
                :items="lines"
                label="Seleccione linea de lote"
                no-data-text="No hay datos"
                solo
                dense
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span>Microorganismo</span>
              <v-autocomplete
                v-model="form.mo"
                :search-input.sync="search"
                :items="identificationsFounded"
                :loading="loader"
                return-object
                solo
                dense
                clearable
                item-text="identificationName"
                no-data-text="No se ha encontrado"
                label="Selecciona microorganismo"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span>Selecciona etapa de producción</span>
              <v-autocomplete
                v-model="form.productionState"
                :items="productionStates"
                label="Seleccione estatus"
                no-data-text="No hay datos"
                solo
                dense
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-container>
          <v-row>
            <v-col cols="12" xl="4" lg="4" md="4">
              <v-btn color="gray" dark @click="show = false" block>
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="12" xl="4" lg="4" md="4">
              <v-btn color="info" @click="cleanFilters" block>
                Limpiar filtros
              </v-btn>
            </v-col>
            <v-col cols="12" xl="4" lg="4" md="4">
              <v-btn color="primary" @click="applyFilters" block>
                Aplicar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapMutations } from "vuex";
//axios
import axios from "axios";
export default {
  data: () => ({
    form: {
      mo: null,
      line: null,
      productionState: null,
    },
    lines: [
      { text: "Hongo", value: "H" },
      { text: "Bacteria", value: "B" },
      { text: "Actinomicetos", value: "AS" },
      { text: "Fertilizante", value: "F" },
    ],
    productionStates: [
      { text: "Lote creado", value: "BATCH_CREATED" },
      { text: "Preinóculo", value: "PREINOCULATE" },
      { text: "1 validación", value: "1_VALIDATION" },
      { text: "2 validación", value: "2_VALIDATION" },
      { text: "Incubando", value: "INCUBATING" },
      { text: "Secando", value: "DRYING" },
      { text: "Molido/Tamizado", value: "SIFTING" },
      { text: "Stock de espora", value: "STOCK" },
      { text: "Stock de producto terminado", value: "STOCK_PT" },
    ],
    loader: false,
    search: null,
    identificationsFounded: [],
  }),
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("bioactives", ["searchBioactives"]),
    ...mapMutations(["SET_CANCEL_TOKEN"]),
    cleanFilters() {
      this.form = {
        mo: null,
        line: null,
        productionState: null,
      };
      this.search = null;
      this.identificationsFounded = [];

      this.$emit("filter", this.form);
      this.show = false;
    },
    applyFilters() {
      this.$emit("filter", this.form);
      this.show = false;
    },
  },
  watch: {
    async search(val) {
      if (!val) return;
      else {
        this.loader = true;

        if (typeof this.cancelToken != typeof undefined) {
          this.cancelToken.cancel("Operation canceled due to new request.");
        }

        //Save the cancel token for the current request
        this.SET_CANCEL_TOKEN(axios.CancelToken.source());

        try {
          const response = await this.searchBioactives({
            name: val,
          });
          if (response.error) throw response;

          this.identificationsFounded = response.strains;
        } catch (e) {
          console.log(e);
        }
        this.loader = false;
      }
    },
  },
  destroyed() {
    this.form = {
      mo: null,
      line: null,
      productionState: null,
    };
    this.search = null;
    this.identificationsFounded = [];
  },
};
</script>
